class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // 🔥 Inject content
          this.innerHTML = recommendations.innerHTML;

          // 🔥 Wait for DOM paint, then init Slick
          requestAnimationFrame(() => {
            this.initSlider();
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  initSlider() {
    const $el = $(this).find(".mini-cart__navigation");

    if (!$el.length || !$el.children().length) {
      console.log("⚠️ No slides for recommendations");
      return;
    }

    // 🔥 Destroy if already initialized (important for re-renders)
    if ($el.hasClass("slick-initialized")) {
      $el.slick("unslick");
    }

    $el.slick({
      dots: false,
      arrows: true,
      appendArrows: $(this).find(".cart-rec-arrows"),
      infinite: false,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    // 🔥 Fix width/layout issues
    $el.slick("setPosition");

    console.log("✅ Recommendations slick initialized inside component");
  }
}

customElements.define('cart-recommendations', CartRecommendations);